export default {
  init() {
    // JavaScript to be fired on the home page
    /* window load */
    jQuery(window).load(function() {
        /* banner slider */
        jQuery('.saxon-slider').slick({
            autoplay: false,
        });
        
        /* departments slider */
        jQuery('.departments-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: 'unslick',
                },
            ],
        });
        
        /* banner slider */
        jQuery('.events-slider').slick({
            autoplay: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        adaptiveHeight: true,
                    },
                },
            ],
        });
        
        /* department section tab + slider */
        function tabSlider(){
            jQuery('.products-wrapper').slick({
                dots: false,
                infinite: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 2000,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            adaptiveHeight: true,
                        },
                    },
                ],
            });
        }
        tabSlider();

        //tabbed content in homepage - featured product
        jQuery('ul.tabs li').click(function() {
            var tab_id = jQuery(this).attr('data-tab');
            jQuery('ul.tabs li').removeClass('current');
            jQuery('.tab-content').removeClass('current');
            jQuery(this).addClass('current');
            jQuery("#" + tab_id).addClass('current');
            jQuery('.products-wrapper').slick('unslick');
            tabSlider();
            
            if(jQuery(window).width() > 575){
                jQuery('.current .eq-height').matchHeight();
            }else{
                jQuery('.current .eq-height').matchHeight({
                    remove: true,
                });
                
                /* slide to tab content */
                jQuery('html, body').animate({
                    scrollTop: jQuery('.tab-content.current').offset().top - 50,
                }, 600);
            }
        });
        if (window.location.hash.length > 0) {
            var hash_str = window.location.hash.split("#")[1];
            jQuery('.tab-link[data-tab=' + hash_str + ']').click();
        }
        
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js